function initializeDewGlowDropdown() {
  var customDropdown = document.querySelector('.custom-dropdown');
  if (!customDropdown) return;

  var dropdownSelected = customDropdown.querySelector('.dropdown-selected');
  var dropdownOptions = customDropdown.querySelector('.dropdown-options');
  var hiddenInput = document.getElementById('selectedVariantId'); // Hidden input for Add to Cart
  var selectedTitle = customDropdown.querySelector('.selected-title');
  var swatchSelected = customDropdown.querySelector('.swatch-selected');

  dropdownSelected.addEventListener('click', function (event) {
    event.stopPropagation();
    dropdownOptions.style.display = dropdownOptions.style.display === "block" ? "none" : "block";
  });

  var options = customDropdown.querySelectorAll('.dropdown-option');
  options.forEach(function (option) {
    option.addEventListener('click', function (event) {
      event.stopPropagation();
      var variantId = this.getAttribute('data-value');
      var optionTitle = this.getAttribute('data-title');
      var swatchImageUrl = this.getAttribute('data-swatch');

      // Update hidden input so Add to Cart works
      hiddenInput.value = variantId;

      // Update dropdown display
      selectedTitle.textContent = optionTitle;
      swatchSelected.style.backgroundImage = 'url(' + swatchImageUrl + ')';
      swatchSelected.style.backgroundSize = 'cover';
      swatchSelected.style.backgroundPosition = 'center';

      // Hide the dropdown after selection
      dropdownOptions.style.display = "none";

      // Find and click the correct label to change the variant
      var variantLabel = Array.from(document.querySelectorAll("label"))
        .find(label => label.textContent.trim() === optionTitle);

      if (variantLabel) {
        console.log("Clicking label for variant:", optionTitle);
        variantLabel.click();
      }
    });
  });

  // Ensure the first variant is selected on page load
  var defaultOption = customDropdown.querySelector('.dropdown-option[data-default="true"]');
  if (defaultOption) {
    var variantId = defaultOption.getAttribute('data-value');
    hiddenInput.value = variantId; // Ensure Add to Cart uses correct variant
    selectedTitle.textContent = defaultOption.getAttribute('data-title');
    var defaultSwatch = defaultOption.getAttribute('data-swatch');
    swatchSelected.style.backgroundImage = 'url(' + defaultSwatch + ')';
    swatchSelected.style.backgroundSize = 'cover';
    swatchSelected.style.backgroundPosition = 'center';
  } else if (options.length > 0 && !hiddenInput.value) {
    var firstOption = options[0];
    var variantId = firstOption.getAttribute('data-value');
    hiddenInput.value = variantId; //  Ensure Add to Cart uses correct variant
    selectedTitle.textContent = firstOption.getAttribute('data-title');
    var firstSwatch = firstOption.getAttribute('data-swatch');
    swatchSelected.style.backgroundImage = 'url(' + firstSwatch + ')';
    swatchSelected.style.backgroundSize = 'cover';
    swatchSelected.style.backgroundPosition = 'center';
  }

  // Close the dropdown when clicking outside
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.custom-dropdown')) {
      dropdownOptions.style.display = "none";
    }
  });
}

// Ensure variant updates when Shopify triggers a variant change
document.addEventListener("variant:change", function(event) {
  let variant = event.detail.variant;
  if (!variant) return;

  console.log("Variant changed:", variant.id, variant.title);

  var matchingOption = document.querySelector(`.dropdown-option[data-title="${variant.title}"]`);
  if (matchingOption) {
    var variantId = matchingOption.getAttribute('data-value');
    var swatchImageUrl = matchingOption.getAttribute('data-swatch');

    var hiddenInput = document.getElementById('selectedVariantId');
    var selectedTitle = document.querySelector('.selected-title');
    var swatchSelected = document.querySelector('.swatch-selected');

    hiddenInput.value = variantId; // Ensure Add to Cart uses correct variant
    selectedTitle.textContent = variant.title;
    swatchSelected.style.backgroundImage = 'url(' + swatchImageUrl + ')';
    swatchSelected.style.backgroundSize = 'cover';
    swatchSelected.style.backgroundPosition = 'center';
  }

  initializeDewGlowDropdown();
});

// Run when the page loads
document.addEventListener("DOMContentLoaded", function () {
  initializeDewGlowDropdown();
});
